import * as React from 'react';

interface AssetBoardCardDescription {
  leftText: string;
  rightText: string;
  pillStyling: string;
}
// simple grid setup view
const AssetBoardCardDescription: React.FunctionComponent<AssetBoardCardDescription> = ({ leftText, rightText, pillStyling }) => (
  <div className="description-container">
    <span className="left-text">{ leftText }</span>
    <span className="right-text"><span className={pillStyling}>{ rightText }</span></span>
  </div>
);

export default AssetBoardCardDescription;
